module.exports = __webpack_public_path__ + "01ea978f/img/settings-icon.121d9519.svg";